<div class="orders-history">
  @if (isLoading()) {
    <div class="orders-history__empty">
      {{ 'customers.orderHistory.loading' | translate }}
    </div>
  } @else if (orders().length > 0) {
    <div class="orders-history__table-wrapper">
      <table class="orders-history__table">
        <thead>
          <tr>
            <th>{{ 'customers.orderHistory.columns.order' | translate }}</th>
            <th>{{ 'customers.orderHistory.columns.dateCreated' | translate }}</th>
            <th>{{ 'customers.orderHistory.columns.deliveryType' | translate }}</th>
            <th>{{ 'customers.orderHistory.columns.status' | translate }}</th>
            <th>{{ 'customers.orderHistory.columns.creator' | translate }}</th>
          </tr>
        </thead>

        <tbody>
          @for (order of orders(); track order.id) {
            <tr>
              <td class="orders-history__order-number">
                {{ order.orderNumber }}
              </td>

              <td class="orders-history__date">
                {{ order.createdAt | date: 'yyyy-MM-dd HH:mm:ss' }}
              </td>

              <td class="orders-history__delivery">
                {{ order.deliveryType }}
              </td>

              <td>
                <span [class]="getStatusClass(order.status)">
                  {{ order.status }}
                </span>
              </td>

              <td class="orders-history__creator">
                {{ order.creator }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="orders-history__empty">
      {{ 'customers.orderHistory.empty' | translate }}
    </div>
  }

  <div class="orders-history__actions">
    <button type="button" class="orders-history__close-btn" (click)="onClose()">
      {{ 'customers.orderHistory.close' | translate }}
    </button>
  </div>
</div>
